<template>
  <b-form-group
    label="11. Potensi Pemanfaatan"
    label-for="potensiPemanfaatan"
  >
    <b-col
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-group
        v-if="isLantaiDigunakan === '1'"
        label="a. Apakah Terdapat Lantai Yang Tidak Digunakan ?"
        label-for="isLantaiDigunakan"
      >
        <b-form-radio
          v-model="isLantaiDigunakan"
          value="1"
          disabled
        >
          Ya
        </b-form-radio>
        <b-col
          cols="11"
          offset-md="1"
          class="mt-1 pr-0"
        >
          <b-form-group
            label="Jumlah Seluruh Lantai"
            label-for="jumlahSeluruhLantai"
          >
            <b-form-input
              v-model="jumlahSeluruhLantai"
              disabled
            />
          </b-form-group>
          <b-form-group
            label="Jumlah Lantai Yang Digunakan"
            label-for="jumlahLantaiDigunakan"
          >
            <b-form-input
              v-model="jumlahLantaiDigunakan"
              disabled
            />
          </b-form-group>
          <b-form-group
            label="Jumlah Lantai Yang Tidak Digunakan"
            label-for="jumlahLantaiTidakDigunakan"
          >
            <slot name="jumlahLantaiTidakDigunakan" />
          </b-form-group>
        </b-col>
        <b-form-radio
          v-model="isLantaiDigunakan"
          value="0"
          disabled
        >
          Tidak
        </b-form-radio>
      </b-form-group>

      <b-form-group
        v-if="isAtapBeton === '1' && isAtapBetonIsDigunakan === '1'"
        label="b. Atap Beton"
        label-for="isAtapBeton"
      >
        <b-form-radio
          v-model="isAtapBeton"
          value="1"
          disabled
        >
          Ada (Memiliki Atap Beton)
        </b-form-radio>
        <b-col
          cols="11"
          offset-md="1"
        >
          <b-form-radio
            v-model="isAtapBetonIsDigunakan"
            value="1"
            disabled
          >
            Digunakan
          </b-form-radio>
          <b-col
            cols="11"
            offset-md="1"
            class="mt-1 pr-0"
          >
            <b-form-group
              label="Digunakan Untuk"
              label-for="atapBetonDigunakan"
            >
              <slot name="atapBetonDigunakan" />
            </b-form-group>
          </b-col>
          <b-form-radio
            v-model="isAtapBetonIsDigunakan"
            value="0"
            disabled
          >
            Tidak Digunakan
          </b-form-radio>
        </b-col>
        <b-form-radio
          v-model="isAtapBeton"
          value="0"
          disabled
        >
          Tidak Ada Atap Beton
        </b-form-radio>
      </b-form-group>

      <b-form-group
        v-if="isBasement === '1' && isBasementIsDigunakan === '1'"
        label="c. Basement"
        label-for="isBasement"
      >
        <b-form-radio
          v-model="isBasement"
          value="1"
          disabled
        >
          Ada (Memiliki Basement)
        </b-form-radio>
        <b-col
          cols="11"
          offset-md="1"
        >
          <b-form-radio
            v-model="isBasementIsDigunakan"
            value="1"
            disabled
          >
            Digunakan
          </b-form-radio>
          <b-col
            cols="11"
            offset-md="1"
            class="mt-1 pr-0"
          >
            <b-form-group
              label="Digunakan Untuk"
              label-for="basementDigunakan"
            >
              <slot name="basementDigunakan" />
            </b-form-group>
          </b-col>
          <b-form-radio
            v-model="isBasementIsDigunakan"
            value="0"
            disabled
          >
            Tidak Digunakan
          </b-form-radio>
        </b-col>
        <b-form-radio
          v-model="isBasement"
          value="0"
          disabled
        >
          Tidak Ada Basement
        </b-form-radio>
      </b-form-group>

      <b-form-group
        v-if="isHalamanUtama === '1' && isHalamanUtamaIsDigunakan === '1'"
        label="d. Halaman / Taman"
        label-for="isHalamanUtama"
      >
        <b-form-radio
          v-model="isHalamanUtama"
          value="1"
          disabled
        >
          Ada (Memiliki Halaman / Utama)
        </b-form-radio>
        <b-col
          cols="11"
          offset-md="1"
          class="mt-1 pr-0"
        >
          <b-form-radio
            v-model="isHalamanUtamaIsDigunakan"
            value="1"
            disabled
          >
            Digunakan
          </b-form-radio>
          <b-col
            cols="11"
            offset-md="1"
            class="mt-1 pr-0"
          >
            <b-form-group
              label="Digunakan Untuk"
              label-for="halamanUtamaDigunakan"
            >
              <slot name="halamanUtamaDigunakan" />
            </b-form-group>
          </b-col>
          <b-form-radio
            v-model="isHalamanUtamaIsDigunakan"
            value="0"
            disabled
          >
            Tidak Digunakan
          </b-form-radio>
        </b-col>
        <b-form-radio
          v-model="isHalamanUtama"
          value="0"
          disabled
        >
          Tidak Ada Halaman / Utama
        </b-form-radio>
      </b-form-group>
    </b-col>
  </b-form-group>
</template>
<script>
export default {
  props: {
    isLantaiDigunakan: { type: String, default: null },
    jumlahSeluruhLantai: { type: String, default: null },
    jumlahLantaiDigunakan: { type: String, default: null },
    isAtapBeton: { type: String, default: null },
    isAtapBetonIsDigunakan: { type: String, default: null },
    isBasement: { type: String, default: null },
    isBasementIsDigunakan: { type: String, default: null },
    isHalamanUtama: { type: String, default: null },
    isHalamanUtamaIsDigunakan: { type: String, default: null },
  },
}
</script>
